import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { TopNotificationBarComponent } from '@app/modules/top-notification/top-notification-bar.component';

@Component({
    selector: 'app-page',
    templateUrl: './app-page.component.html',
    styleUrls: ['./app-page.component.scss'],
    imports: [TopNotificationBarComponent, RouterOutlet],
})
export class AppPageComponent {}
